import IDocument from "../models/IDocument";

class DocumentFunctions {
    static ContainsSerachText(
        document: IDocument,
        searchText: string
    ): boolean {
        return (
            (document.title !== null &&
                document.title.toLowerCase().includes(searchText)) ||
            (document.description !== null &&
                document.description
                    .toString()
                    .toLowerCase()
                    .includes(searchText)) ||
            (document.uploadedBy !== null &&
                document.uploadedBy
                    .toString()
                    .toLowerCase()
                    .includes(searchText))
        );
    }
}

export default DocumentFunctions;
